import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';

const API_URL = environment.apiUrl + 'team';
@Injectable({
    providedIn: 'root'
})
export class TeamService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getTeamList(query): Observable<any> {
        return this.http.get(API_URL + query);
    }
    getTeamListWithoutAuth(query): Observable<any> {
        return this.http.get(API_URL + '/v1' + query);
    }
    getTeamDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id);
    }
    getTeamDetailsWithoutAuth(id): Observable<any> {
        return this.http.get(API_URL + '/v1/' + id);
    }
    updateTeam(id, data): Observable<any> {
        return this.http.put(API_URL + '/' + id, data);
    }
    addTeam(productdata): Observable<any> {
        return this.http.post(API_URL, productdata);
    }

    private teamId = new BehaviorSubject('');
    _teamId = this.teamId.asObservable();

    passTeamId(val: any) {
        this.teamId.next(val);
    }

    addPointsTable(data) {
        return this.http.post(`${environment.apiUrl}pointstable`,data);
    }

    updatePointsTable(id,data) {
        return this.http.put(`${environment.apiUrl}pointstable/${id}`,data);
    }

    getPointsTableById(id:string) {
        return this.http.get(`${environment.apiUrl}pointstable/${id}`);
    }

    getPointsTable(query:string) {
        return this.http.get(`${environment.apiUrl}pointstable${query}`);
    }
    getV1PointsTable(query:string) {
        return this.http.get(`${environment.apiUrl}pointstable/v1${query}`);
    }

    addPlayerStatistics(data) {
        return this.http.post(`${environment.apiUrl}playerstastics`,data);
    }

    updatePlayerStatistics(id,data) {
        return this.http.put(`${environment.apiUrl}playerstastics/${id}`,data);
    }

    getPlayerStatisticsById(id:string) {
        return this.http.get(`${environment.apiUrl}playerstastics/${id}`);
    }

    getPlayerStatistics(query:string) {
        return this.http.get(`${environment.apiUrl}playerstastics${query}`);
    }
}